import { ITranslation, IValueLanguage } from '@shared/models/language.model';
import { GalleryDisplayType } from '@shared/enums/GalleryDisplayType';
import { GalleryAccessType } from '@shared/enums/GalleryAccessType';

export interface IGallery {
    id: string;
    galleryDisplayType: GalleryDisplayType;
    galleryAccessType: GalleryAccessType;
    titles: ITranslation[];
    contents: ITranslation[];
    files: IFile[];
}

export class Gallery implements IGallery {
    constructor(
        public id: string,
        public galleryDisplayType: GalleryDisplayType,
        public galleryAccessType: GalleryAccessType,
        public titles: ITranslation[],
        public contents: ITranslation[],
        public files: IFile[]
    ) {}
}

export interface IFile {
    id: string;
    index: number;
    displayName: string;
    url: string;
    contentType: string;
    translations: ITranslation[];
}

export class File implements IFile {
    constructor(
        public id: string,
        public index: number,
        public displayName: string,
        public url: string,
        public contentType: string,
        public translations: ITranslation[]
    ) {}
}

export interface IAddGallery {
    galleryDisplayType: GalleryDisplayType;
    galleryAccessType: GalleryAccessType;
    titles: IValueLanguage[];
    contents: IValueLanguage[];
    files: IFile[];
}

export class AddGallery implements IAddGallery {
    constructor(
        public galleryDisplayType: GalleryDisplayType,
        public galleryAccessType: GalleryAccessType,
        public titles: IValueLanguage[],
        public contents: IValueLanguage[],
        public files: File[]
    ) {}
}

export interface IUpdateGallery {
    galleryDisplayType: GalleryDisplayType;
    galleryAccessType: GalleryAccessType;
    titles: ITranslation[];
    contents: ITranslation[];
    files: File[];
}

export class UpdateGallery implements IUpdateGallery {
    constructor(
        public galleryDisplayType: GalleryDisplayType,
        public galleryAccessType: GalleryAccessType,
        public titles: ITranslation[],
        public contents: ITranslation[],
        public files: File[]
    ) {}
}
